import { motion } from "framer-motion";
import { SectionLabel } from "@/components/Section";

export default function Promise() {
  return (
    <section data-testid="section-promise" className="bg-white px-5 py-20 lg:py-28">
      <div className="mx-auto max-w-7xl grid gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:items-end">
        <div>
          <SectionLabel>The OneHill Promise</SectionLabel>
          <motion.h2
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5 }}
            className="mt-6 text-4xl sm:text-5xl lg:text-6xl font-display font-black tracking-tight leading-[1.05]"
          >
            Expansion is easy to announce. <span className="text-[#99CC00]">Difficult to execute.</span>
          </motion.h2>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="rounded-[2rem] bg-[#F7F8F5] p-8 lg:p-10"
        >
          <p className="text-lg lg:text-xl leading-relaxed text-neutral-600">
            Quick commerce companies can identify cities, lease stores and plan launches — but store-level execution decides whether expansion actually succeeds.
          </p>
          <p className="mt-5 text-lg lg:text-xl leading-relaxed font-black text-[#1F1F1F]">
            OneHill becomes the ground execution layer: manpower, SOPs, compliance, daily MIS and operational accountability.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
